// removed by extract-text-webpack-plugin
module.exports = {"Work":"Work___2CXDg","h1":"h1___3Ndqh","a":"a___2Iu3y","i":"i___2bJL6","work":"work___2-vMv","h3":"h3___3H4hM","h4":"h4___3nLSE","p":"p___3VUa-","awardsList":"awardsList___fjelc","award":"award___1i4Bz","img":"img___GTEjL","sketch":"sketch___1Trqb"};


//////////////////
// WEBPACK FOOTER
// ./app/js/components/Work/style.scss
// module id = 121
// module chunks = 0